import React, { useState } from 'react';

export const TruncatedText = ({ text, maxLength = 100, className = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text || text.length <= maxLength) {
    return <span className={className}>{text || '--'}</span>;
  }

  const displayText = isExpanded ? text : text.slice(0, maxLength) + '...';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%'
      }}>
      <div
        className={className}
        style={{
          wordBreak: 'break-word',
          whiteSpace: 'pre-wrap',
          overflowWrap: 'break-word',
          width: '100%',
          maxWidth: '100%'
        }}>
        {displayText}
      </div>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="hover:underline text-sm font-medium"
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          margin: 0,
          marginTop: '0.5rem',
          alignSelf: 'flex-start',
          color: '#3766A8'
        }}>
        {isExpanded ? 'View less' : 'View more'}
      </button>
    </div>
  );
};
